<template>
    <div class="vrm-status" :class="{ alarm: alarm }">
        <div class="vrm-status__info">
            <div>{{ $t('common.last_update') }} :</div>
            <div v-if="realtime" class="vrm-status__info__value">
                {{ $t('common.realtime') }}
                <img class="realtime-icon" src="/img/svg-icons/realtime.svg" />
            </div>
            <div v-if="!realtime && time > 0" class="vrm-status__info__value">
                {{ lastTimeUpdate }}
            </div>
        </div>
        <div class="vrm-status__info">
            <div>{{ $t('common.status') }} :</div>
            <div v-if="!alarm" class="vrm-status__info__value">{{ $t('common.status_ok') }}</div>
            <div v-if="alarm" class="vrm-status__info__value">{{ $t('common.status_alarm') }}</div>
        </div>
        <div class="vrm-status__info">
            <div>{{ $t('common.local_time') }} :</div>
            <div class="vrm-status__info__value">{{ localTime }}</div>
        </div>
        <div
            v-if="
                realtime &&
                    enabledOpenControlsButton &&
                    openDevicesDrawer &&
                    !controlDevicesDrawerOpen
            "
            class="vrm-status__info"
        >
            <vrm-icon-button
                icon-class="sg-vrm-icon_118_settings-17px"
                class="vrm-control-settings"
                @click="openDevicesDrawer()"
            ></vrm-icon-button>
        </div>
        <slot></slot>
    </div>
</template>
<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import { AngularDirective } from '@/vue/decorators/angular-interop';
import { AngularLocaleBundle } from '@/angular-bridge/modules/i18n';
import moment from 'moment';

@Component()
@AngularDirective('vrm-status-vue')
@AngularLocaleBundle('common')
export default class VrmStatus extends Vue {
    @Prop()
    realtime;
    @Prop()
    time;
    @Prop()
    timezone;
    @Prop()
    offset;
    @Prop()
    alarm;
    @Prop()
    openDevicesDrawer;
    @Prop()
    enabledOpenControlsButton;
    @Prop()
    controlDevicesDrawerOpen;

    get lastTimeUpdate() {
        return moment.unix(this.time).fromNow();
    }

    get localTime() {
        return moment()
            .utcOffset(this.offset)
            .format('HH:mm');
    }
}
</script>
